const SALES_MOCK = {
  count: 2,
  next: "sdsldklsdk",
  previous: "sdsldklsdk",
  results: [
    {
      code: "11111111",
      order_id: "BP197547",
      name: "Evento 01",
      shopper_name: "Nome do comprador",
      shopper_email: "email@zeuspay.com.br",
      shopper_phone: "(99) 91231-1231",
      shopper_document: "00000000",
      ticket_code: "<ticket_code>",
      ticket_name: "Lote 01",
      event_start_at: "2024-01-01 08:05",
      payment_type: "card",
      installments: 1,
      commission: 8.56,
      status: "created"
    },
    {
      code: "22222",
      order_id: "BP197548",
      name: "Evento 02",
      shopper_name: "Nome do comprador 2",
      shopper_email: "email2@zeuspay.com.br",
      shopper_phone: "(99) 91231-1231",
      shopper_document: "00000000",
      ticket_code: "<ticket_code>",
      ticket_name: "Lote 01",
      event_start_at: "2024-01-01 08:05",
      payment_type: "card",
      installments: 10,
      commission: 8.56,
      status: "created"
    }
  ]
};

const PARTICIPANTS_MOCK = {
  count: 1,
  next: null,
  previous: null,
  results: [
    {
      code: "1111",
      order_id: "BP197547",
      shopper_name: "Nome do comprador",
      shopper_email: "email@zeuspay.com.br",
      shopper_phone: "(99) 91231-1231",
      shopper_document: "00000000",
      ticket_code: "THRM-CD-8JJD",
      ticket_name: "Lote 01",
      checkin_at: "2024-01-01 08:05",
      checkin_user_name: "colaborador 1"
    },
    {
      code: "2222",
      order_id: "BP197547",
      shopper_name: "Nome do comprador",
      shopper_email: "email@zeuspay.com.br",
      shopper_phone: "(99) 91231-1231",
      shopper_document: "00000000",
      ticket_code: "THRM-CD-8JJD",
      ticket_name: "Lote 01",
      checkin_at: null,
      checkin_user_name: "colaborador 1"
    }
  ]
};

const PARTICIPANT_HISTORY_MOCK = {
  count: 1023,
  total_amount: 2000,
  next: null,
  previous: null,
  results: [
    {
      user_type: "producer",
      activity_type: "imported",
      created_at: "2023-01-01 00:00:00",
      metadata: {
        producer_name: "Alexandre Morais",
        lead_name: "Gabriel Santos"
      }
    },
    {
      user_type: "producer",
      activity_type: "assigned",
      created_at: "2023-01-01 00:00:00",
      metadata: {
        producer_name: "Alexandre Morais",
        seller_name: "Rodrigo de Freitas",
        stage_name: "Base"
      }
    },
    {
      user_type: "producer",
      activity_type: "seller_inactivated",
      created_at: "2023-01-01 00:00:00",
      metadata: {
        producer_name: "Alexandre Morais",
        seller_name: "Rodrigo de Freitas",
        stage_name: "Base"
      }
    },
    {
      user_type: "producer",
      activity_type: "changed_assigned",
      created_at: "2023-01-01 00:00:00",
      metadata: {
        producer_name: "Alexandre Morais",
        seller_name_new: "Marcos Ricardo",
        seller_name: "Rodrigo de Freitas",
        stage_name: "Base"
      }
    },
    {
      user_type: "producer",
      activity_type: "changed_stage",
      created_at: "2023-01-01 00:00:00",
      metadata: {
        producer_name: "Alexandre Morais",
        stage_name: "Em negociação",
        stage_name_new: "Aguardando Compra"
      }
    }
  ]
};
export default {
  getSales(context, params) {
    return new Promise((resolve, reject) => {
      context.commit("setSales", SALES_MOCK.results);
      context.commit("setPagination", {
        count: SALES_MOCK.count,
        next: SALES_MOCK.next,
        previous: SALES_MOCK.previous
      });
      resolve(SALES_MOCK.results);
      // const queryString = new URLSearchParams(params).toString();
      // return window.axios
      //   .get(`/gateways/reports/order?${queryString}`, config)
      //   .then(({ data: { count, next, previous, results } }) => {
      //     context.commit("setSales", results);
      //     context.commit("setPagination", {
      //       count,
      //       next,
      //       previous
      //     });
      //     resolve({ count, next, previous, results });
      //   })
      //   .catch(reject);
    });
  },
  getParticipants(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/event-management/tickets?${queryString}`)
        .then(({ data: { count, next, previous, results } }) => {
          context.commit("setParticipants", results);
          context.commit("setPagination", { count, next, previous });
          resolve(results);
        })
        .catch(reject);
    });
  },
  editParticipant(context, params) {
    return new Promise((resolve, reject) => {
      return window.axios
        .patch(`/event-management/tickets/${params.code}`, params.data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
  exportParticipants(context) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/event-management/tickets?export=true`)
        .then(resolve)
        .catch(reject);
    });
  },
  getParticipantHistory(context, params) {
    return new Promise((resolve, reject) => {
      resolve(PARTICIPANT_HISTORY_MOCK);
      // const queryString = new URLSearchParams(params).toString();
      // return window.axios
      //   .get(`/gateways/reports/order?${queryString}`, config)
      //   .then(({ data: { count, next, previous, results } }) => {
      //     context.commit("setSales", results);
      //     context.commit("setPagination", {
      //       count,
      //       next,
      //       previous
      //     });
      //     resolve({ count, next, previous, results });
      //   })
      //   .catch(reject);
    });
  },

  getTicketsOverview(context, id) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/event-management/report/tickets/overview?product_id=${id}`)
        .then(({ data }) => {
          context.commit("setTicketsOverview", data);
          resolve(data);
        })
        .catch(reject);
    });
  },

  checkIn(context, params) {
    return new Promise((resolve, reject) => {
      return window.axios
        .patch(`/event-management/tickets/${params.code}`, {
          checkin_at: params.checkin_at
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
  getCheckIn(context, code) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/event-management/tickets/${code}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
  resendEmail(context, code) {
    return new Promise((resolve, reject) => {
      return window.axios
        .post(`/event-management/tickets/resend-email/${code}`)
        .then(resolve)
        .catch(reject);
    });
  },

  createLot(context, data) {
    return new Promise((resolve, reject) => {
      return window.axios
        .post(`/event-management/lots`, data)
        .then(resolve)
        .catch(reject);
    });
  },
  getLots(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/event-management/lots?${queryString}`)
        .then(({ data: { results, next, previous, count } }) => {
          context.commit("setPagination", { next, previous, count });
          context.commit("setLots", results);
          resolve(results);
        })
        .catch(reject);
    });
  },
  getLot(context, code) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/event-management/lots/${code}`)
        .then(({ data }) => {
          context.commit("setLot", data);
          resolve(data);
        });
    });
  },
  editLot(context, data) {
    return new Promise((resolve, reject) => {
      return window.axios
        .put(`/event-management/lots/${data.code}`, data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },

  getSalesTickets(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/sales/tickets?${queryString}`)
        .then(({ data: { results, next, previous, count } }) => {
          context.commit("setPagination", { next, previous, count });
          context.commit("setTickets", results);
          resolve(results);
        })
        .catch(reject);
    });
  }
};
